import React, { useEffect, useState, useContext } from "react";
import PatientsTableInformation from "../../../components/PatientsInformationTable/PatientsInformationTable";
import Pagination from "../../../components/pagination";
import { isArrayEmpty, isNull } from "../../../utils/utils";
import { HistoryFilterContext } from "../historyFilterContext";
import Loader from "../../../components/Loader/loader";
import { STORAGE_KEYS, getDataLocally } from "../../../utils/localStorage";
import { Typography } from "@mui/material";
import { useHomeTab, TAB_DISEASE_TYPES, TAB_FIELD_MAPPINGS, TAB_RECORD_FETCHERS } from "../Home/homeTabContext";

const UserHistory = (props) => {
  const { activeTab } = useHomeTab();

  return (
    <HistoryContent
      key={activeTab}
      fieldMapping={TAB_FIELD_MAPPINGS[activeTab]}
      diseaseType={TAB_DISEASE_TYPES[activeTab]}
      fetchRecords={TAB_RECORD_FETCHERS[activeTab]}
    />
  );
};

const HistoryContent = ({ fieldMapping, diseaseType, fetchRecords }) => {
  const [records, setRecords] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [showLoader, setLoader] = useState(false);
  const [page] = useState(1);
  const { filters } = useContext(HistoryFilterContext);
  const getLoggedInOrganization = getDataLocally(STORAGE_KEYS.LOGIN_ORGANIZATION);

  useEffect(() => {
    if (fetchRecords) getPatientRecords(page);
  }, [page, filters]);

  async function getPatientRecords(pageNo) {
    setLoader(true);
    let param = {
      page_no: pageNo,
      ...filters,
      org_id: getLoggedInOrganization.org_id,
      user_id: getLoggedInOrganization.user_id,
      role_id: getLoggedInOrganization.role_id,
      disease_type: diseaseType,
    };
    await fetchRecords(param)
      .then((res) => {
        if (!isNull(res.body)) {
          setRecords(res.body.data);
          setDataCount(res.body.dataCount);
        }
        setLoader(false);
      })
      .catch(() => setLoader(false));
  }

  const onPageChange = async (pageNo) => {
    await getPatientRecords(pageNo);
  };

  return (
    <>
      <Loader show={showLoader} />
      <PatientsTableInformation patientData={records} fieldMapping={fieldMapping} />
      {!isArrayEmpty(records) ? (
        <Pagination dataCount={dataCount} pageChangeCallBack={onPageChange} />
      ) : (
        <Typography textAlign={"center"} paddingTop={8} variant="h6">
          There is no data available
        </Typography>
      )}
    </>
  );
};

export default UserHistory;
